import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

export const WORK_CHAPTERS = [
  { key: "intro", label: "Introduction", to: "/work" },
  { key: "redbull", label: "Red Bull", to: "/work/red-bull" },
  { key: "kotak", label: "Kotak", to: "/work/kotak" },
  { key: "idfc", label: "IDFC First Bank", to: "/work/idfc" },
  { key: "at20", label: "AT20", to: "/work/at20" },
  { key: "conclusion", label: "Conclusion", to: "/work#work-conclusion" },
];

// Subtle vertical "you are here" rail — desktop/large screens only.
export const ChapterRail = ({ currentKey }) => (
  <nav
    aria-label="Work chapters"
    data-testid="work-rail"
    className="hidden xl:flex fixed right-6 top-1/2 -translate-y-1/2 z-40 flex-col gap-4"
  >
    {WORK_CHAPTERS.map((c) => {
      const active = c.key === currentKey;
      return (
        <Link
          key={c.key}
          to={c.to}
          data-testid={`rail-${c.key}`}
          className="group flex items-center justify-end gap-3"
        >
          <span
            className={`text-[10px] uppercase tracking-[0.2em] font-bold transition-opacity duration-300 ${
              active
                ? "text-white opacity-100"
                : "text-neutral-400 opacity-0 group-hover:opacity-100"
            }`}
          >
            {c.label}
          </span>
          <span
            className={`h-2.5 w-2.5 rounded-full border transition-colors duration-300 ${
              active
                ? "bg-[#e62429] border-[#e62429]"
                : "bg-transparent border-neutral-600 group-hover:border-white"
            }`}
          />
        </Link>
      );
    })}
  </nav>
);

// Quiet prev / next chapter links for the foot of each chapter.
export const ChapterNav = ({ currentKey }) => {
  const idx = WORK_CHAPTERS.findIndex((c) => c.key === currentKey);
  const prev = WORK_CHAPTERS[idx - 1];
  const next = WORK_CHAPTERS[idx + 1];
  return (
    <section data-testid={`${currentKey}-chapter-nav`} className="border-t border-white/10 py-14 sm:py-16">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 grid grid-cols-2 gap-6">
        {prev ? (
          <Link to={prev.to} data-testid={`${currentKey}-prev`} className="group flex flex-col items-start">
            <span className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-bold">Previous</span>
            <span className="mt-2 inline-flex items-center gap-2 sm:gap-3 font-display uppercase text-white text-xl sm:text-3xl leading-none">
              <ArrowLeft className="h-5 w-5 sm:h-6 sm:w-6 text-[#e62429] group-hover:-translate-x-1 transition-transform" />
              {prev.label}
            </span>
          </Link>
        ) : (
          <span />
        )}
        {next ? (
          <Link to={next.to} data-testid={`${currentKey}-next`} className="group flex flex-col items-end text-right justify-self-end">
            <span className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-bold">Next</span>
            <span className="mt-2 inline-flex items-center gap-2 sm:gap-3 font-display uppercase text-white text-xl sm:text-3xl leading-none">
              {next.label}
              <ArrowRight className="h-5 w-5 sm:h-6 sm:w-6 text-[#e62429] group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ) : (
          <span />
        )}
      </div>
    </section>
  );
};
